import React from "react";

// merge more refs into one and make it like functional or object base ref, no more ref pain
export const refs = <T>(...refs: React.Ref<T>[]): React.Ref<T> => {
    const set = (target: any, ...args: any[]) => {
        refs.forEach((ref) => {
            if (ref) {
                if (ref instanceof Function) {
                    ref(args[0]);
                } else if (ref.hasOwnProperty("current")) {
                    (ref as any).current = args[0];
                }
            }
        });
    }
    const o: any = {current: null};
    return new Proxy(o, {
        set(target, p, value, receiver) {
            if (p === "current") {
                set(target, value);
                o.current = value;
                return true;
            } else {
                return Reflect.set(target, p, value, receiver);
            }
        },
        apply: (target, thisArg, args) => {
            set(target, ...args);
        }
    });
}

// make an object ref as functional ref
export const createRef = <T>(initialValue: T = null) => {
    const holder = {current: initialValue};
    return new Proxy(holder, {
        apply: (target, thisArg, args) => {
            holder.current = args[0];
        }
    });
}